import gsap from 'gsap';
import { Graphics, Sprite } from 'pixi.js';

import { Shared } from '../App';
import { Maths } from '../utils/Maths';
import LocalisedText from './LocalisedText';
import { Widget } from './Widget';

export class StatsBarWidget extends Widget
{
    public label: LocalisedText;
    public base: Sprite;
    public fill: Sprite;
    public fillMask: Graphics;
    
    private index: number;

    constructor(index: number)
    {
        super();
        
        this.index = index;
        
        this.base = Sprite.from(Shared.assets.getTexture('stats-empty'));
        this.base.anchor.set(0.5);
        this.view.addChild(this.base);

        this.fill = Sprite.from(Shared.assets.getTexture('stats-full'));
        this.fill.anchor.set(0.5);
        this.view.addChild(this.fill);

        this.fillMask = new Graphics();
        this.fillMask.beginFill(0xFF0000, 0.5);
        this.fillMask.drawRect(0, 0, this.fill.width, this.fill.height);
        this.fillMask.x = this.fill.x - (this.fill.width / 2);
        this.fillMask.y = this.fill.y - (this.fill.height / 2);
        this.fill.mask = this.fillMask;
        this.view.addChild(this.fillMask);

        this.label = new LocalisedText('', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            align: 'right',
            fontSize: 24,
            stroke: 0x333333,
            strokeThickness: 4,
            lineJoin: 'round',
            maxWidth: 200,
        });
        this.label.resolution = 2;
        this.label.anchor.set(1, 0.5);
        this.view.addChild(this.label);
        this.label.x = this.fillMask.x - 10;
    }

    protected async onOpen(): Promise<void>
    {
        gsap.killTweensOf(this.view);
        this.view.x = -200;
        this.view.alpha = 0;
        this.view.updateTransform();
        gsap.to(this.view, { x: 0, alpha: 1, duration: 0.2, ease: 'back.out', delay: this.index * 0.2 });
    }

    protected async onClose(): Promise<void>
    {
        gsap.killTweensOf(this.view);
        this.view.updateTransform();
        gsap.to(this.view, { x: 200, alpha: 0, duration: 0.2, ease: 'back.in', delay: this.index * 0.2 });
    }

    public setValue(label: string, v: number, animated = false): void
    {
        this.label.setText(label);
        const scale = Maths.clamp(v, 0, 1);
        const duration = animated ? 0.2 : 0;

        gsap.killTweensOf(this.fillMask.scale);
        gsap.to(this.fillMask.scale, { x: scale, duration, ease: 'back.out' });
    }
}
